<template>
	<div class="operationsStatistics disBetween">
		<div class="statisticalLeft" v-loading="loading">
			<div class="itemTitleBox disBetween">
				<div class="disStart">
					<span class="title">运营统计</span>
					<div class="myinputBox">
						<el-date-picker :editable="clearable" value-format="yyyy" clearable
							@change="changeTime" v-model="searchData" type="year" placeholder="选择日期">
						</el-date-picker>
					</div>

				</div>
			</div>
			<div class="listBox" >
				<div class="contentBox scrollContBox" >
					<ul ref="scrollview" class="scrollUl" >
						<li class="scrollLi disBetween  scrollLiAct" @click="goUrl('/userManage')">
							<div class="imgBox img1"></div>
							<div class="itemBox ">
								<div class="valueBox">
									用户量
								</div>
								<div class="valueBox">
									<span>{{recordObj.userCount}}</span>个
								</div>
							</div>
						</li>
						<li class="scrollLi disBetween scrollLiAct" @click="goUrl('/chargeManage')">
							<div class="imgBox img2"></div>
							<div class="itemBox ">
								<div class="valueBox">
									服务社区
								</div>
								<div class="valueBox">
									<span>{{recordObj.communityCount}}</span>台
								</div>
							</div>
						</li>
						<li class="scrollLi disBetween scrollLiAct" @click="goUrl('/equipmentInstallationManagement')">
							<div class="imgBox img22"></div>
							<div class="itemBox ">
								<div class="valueBox">
									设备数量
								</div>
								<div class="valueBox">
									<span>{{recordObj.equipmentCount}}</span>台
								</div>
							</div>
						</li>
						<li class="scrollLi disBetween scrollLiAct" >
							<div class="imgBox img3"></div>
							<div class="itemBox ">
								<div class="valueBox">
									电卡销售额
								</div>
								<div class="valueBox">
									<span>{{recordObj.mallAmount}}</span>元
								</div>
							</div>
						</li>
						<li class="scrollLi disBetween longLi " @click="goUrl('/chargingManage')">
							<div class="imgBox img5"></div>
							<div class="itemBox ">
								<div class="valueBox disStart">
									<span class="valueName">累计充电次数</span>
									<span>{{recordObj.rechargeCount}}</span>元
								</div>
								<div class="valueBox disStart">
									<span class="valueName">累计充电收入</span>
									<span>{{recordObj.realConsumeAmount}}</span>元
								</div>
							</div>
						</li>
						<li class="scrollLi disBetween longLi ">
							<div class="imgBox img6"></div>
							<div class="itemBox ">
								<div class="valueBox disStart">
									<span class="valueName">累计营收</span>
									<span>{{recordObj.totalRevenue}}</span>元
								</div>
								<div class="valueBox disStart">
									<span class="valueName">累计收入</span>
									<span>{{recordObj.totalIncome}}</span>元
								</div>
								<div class="valueBox disStart">
									<span  class="valueName">累计提现</span>
									<span>{{recordObj.withdrawalAmount}}</span>元
								</div>
							</div>
						</li>
						
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	export default {
		name: "statisticalAnalysis",
		data() {
			return {
				recordObj: {
					userCount: "",
					communityCount: "",
					equipmentCount: "",
					serviceProviderCount: "",
					repairUserCount: "",
					rechargeCount: "",
					amount: "",
				},
				dialogTitle: "",
				active: 1,
				loading: false,
				clearable: false,
				searchData: "",
			}
		},
		mounted() {
			this.$nextTick(() => {
				this.getData()
			})
		},
		methods: {
			goUrl(str) {
				if (str) {
					this.$emit("goUrl", str)
				}
			},
			changeTime(n) {
				this.$set(this, "searchData", n||"")
				this.$nextTick(() => {
					this.getData()
				})
			},
			getData() {
				this.loading=true
				this.$api.operationalStatistics({
					year: this.searchData
				}).then((res) => {
					if (res.returnCode == 200) {
						this.loading=false
						this.$set(this, "recordObj", res.obj)
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "./operationsStatistics.scss";
</style>